import { Routes } from '@app/constants/routes';
import { TypedNavigate } from '@app/router';

import { AdminEmailModule } from './AdminEmailModule';
import { AdminEmailReportPage } from './report/AdminEmailReportPage';
import { AdminEmailCustomerPage } from './customer/AdminEmailCustomerPage';
import { AdminEmailLogPage } from './log/AdminEmailLogPage';
import { AdminEmailDeliverabilityPage } from './deliverability/AdminEmailDeliverabilityPage';

export const AdminEmailRoutes = {
  path: Routes.admin.email.index,
  element: <AdminEmailModule />,
  children: [
    { path: Routes.admin.email.report, element: <AdminEmailReportPage /> },
    { path: Routes.admin.email.customer.index, element: <AdminEmailCustomerPage /> },
    { path: Routes.admin.email.customer.detail, element: <AdminEmailCustomerPage /> },
    { path: Routes.admin.email.log, element: <AdminEmailLogPage /> },
    { path: Routes.admin.email.deliverability, element: <AdminEmailDeliverabilityPage /> },
    { index: true, path: '*', element: <TypedNavigate to={Routes.admin.email.report} /> },
  ],
};
